exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".eye-closed-1{\n    fill:#f7f7f7;\n}\n\n.eye-closed-2{\n    fill:#586671;\n}\n\n\n", ""]);
